import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SentanceCasePipe } from '@ml/shared/pipes';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  constructor(
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    private sentenceCase: SentanceCasePipe,
    private zone: NgZone
  ) {}

  showMessage(
    message: string,
    interpolateParams: any = null,
    duration: number = 2000,
    action: string = '',
    panelClass?: string[]
  ) {
    let _action = null;
    if (action) {
      _action = this.translate.instant(action);
    }
    this.translate.get(message, interpolateParams).subscribe((text: string) =>
      this.zone.run(() => {
        this.snackBar.open(this.sentenceCase.transform(text), _action, {
          duration,
          panelClass
        });
      })
    );
  }
}
